export default "__VITE_ASSET__0v1baZ7G__"